module.exports = __webpack_public_path__ + "static/project-cp-9c5d993dd39d0c89bbd2ed423b827d44.jpg";